
























































































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { Borough, Clinic } from "@/model/Boroughs";
import ServiceInformation from "@/components/ServiceInformation.vue";
import CallbackForm from "@/components/CallbackForm.vue";
import { interpolateString } from "@/utils";
import { RiskLevelForScore, StringMap } from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";
import { GetSelectedBorough } from "../model/Model";
@Component({
  components: {
    ServiceInformation,
    CallbackForm
  }
})
export default class SupportOverview extends Vue {
  @Prop() public region!: Borough;
  @Prop() public score!: number;

  private get regionName(): string {
    return this.region.displayName || this.region.name;
  }

  @Emit("navigate")
  private handleNavigation(event: string) {
    return event;
  }

  private get bookingLiveLink(): string {
    let name = this.region.name;
    if (GetSelectedBorough() === "Norfolk") {
      name = "Norfolk";
    }
    switch (name) {
      case "West Sussex":
        return "https://bookdrinkcoach.as.me/westsussex";
      case "Norfolk":
        return "https://bookdrinkcoach.as.me/norfolk";
      case "Rotherham":
        return "https://bookdrinkcoach.as.me/rotherham";
      case "Barnet":
        return "https://bookdrinkcoach.as.me/barnet";
      case "Lambeth":
        return "https://bookdrinkcoach.as.me/lambeth";
      case "Lewisham":
        return "https://bookdrinkcoach.as.me/lewisham";
      case "Haringey":
        return "https://bookdrinkcoach.as.me/haringey";
      case "Barnsley":
        return "https://bookdrinkcoach.as.me/barnsley";
      case "Croydon":
        return "https://bookdrinkcoach.as.me/croydon";
      case "Bradford District":
        return "https://bookdrinkcoach.as.me/bradford";
      case "Oxfordshire":
        return "https://bookdrinkcoach.as.me/oxfordshire";
      default:
        return "https://bookdrinkcoach.as.me/";
    }
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get primaryServiceDescription(): string {
    const primaryServiceProvider = this.primaryServiceProvider as Clinic;

    const description =
      primaryServiceProvider.description || primaryServiceProvider.name;
    // Does description need interpolation?
    if (description.indexOf("${") !== -1) {
      const regex = /\${([A-z]+)}/g;
      const map: StringMap<() => { label: string }> = {};
      // ts-lint:disable-next-line: no-conditional-assignment
      let match = regex.exec(description);
      while (match !== null) {
        if (match) {
          const matchVar: string = match[1] as string;
          map[matchVar] = () => ({
            label: primaryServiceProvider[matchVar] as string
          });
        }
        match = regex.exec(description);
      }
      return interpolateString(description, map);
    }
    return description;
  }

  private get primaryServicePhoneNumber(): string {
    const phone = (this.primaryServiceProvider as Clinic).phone;
    if (phone && phone.length) {
      return this.formatPhone(
        phone[0] as string | { title: string; value: string }
      );
    }
    return "";
  }

  private formatPhone(
    phone: string | { title: string; value: string }
  ): string {
    let p: string;
    if (typeof phone === "string") {
      p = phone;
    } else {
      p = phone.value;
    }
    return p.replace(/-/g, " ").replace(/ /g, "&nbsp;");
  }

  @Emit("navigate")
  private gotoSupportFinder(event: Event) {
    event.preventDefault();
    return "find-support";
  }

  private get primaryServiceProvider(): Clinic | null {
    if (this.region.clinics !== undefined) {
      const primaryClinic = this.primaryServiceProviders;
      if (primaryClinic.length) {
        return primaryClinic![0] as Clinic;
      } else {
        return this.region.clinics[0] as Clinic;
      }
    }
    return null;
  }

  private get primaryServiceProviders(): Clinic[] {
    if (this.region.clinics !== undefined) {
      const score = RiskLevelForScore(this.score);
      return (this.region.clinics as Clinic[]).filter(
        clinic =>
          clinic.isPrimaryProvider &&
          (clinic.showAtRiskLevel === undefined ||
            (clinic.showAtRiskLevel as RiskLevel[]).includes(score))
      );
    }
    return [];
  }
}
